// extracted by mini-css-extract-plugin
export var dividerLine = "_9g-3";
export var itemImage = "_9g-9";
export var lightDivider = "_9g-4";
export var modalContent = "_9g-5";
export var modalContentCompact = "_9g-6";
export var productCard = "_9g-a";
export var productImage = "_9g-b";
export var productImageCompact = "_9g-7";
export var productImagePlaceholder = "_9g-c";
export var productImagePlaceholderCompact = "_9g-8";
export var progressBarBackground = "_9g-1";
export var progressBarContainer = "_9g-0";
export var progressBarFill = "_9g-2";